import "./DashboardPage.scss"
import {authStore, growlStore} from "../../../store"
import {observer} from "mobx-react"
import {Receipts, Repository, ShippingReceiptExits, ShippingRecordReceiptExits, Weighings} from "../kpi";
import {DashboardFilterBar} from "./DashboardFilterBar";
import {GrowlBar, GrowlMessage} from "@kroschke/react-ui";
import {AccountButton} from "../../ui";

const DashboardPage = observer(function DashboardPage() {
    const growlMessages = (growlStore.messages || []).map(e => e as GrowlMessage) // this is needed to activate the observer

    return <div className="page-dashboard cmp-page">
        <div className={'growl-bar-area'}>
            <GrowlBar
                // zIndex={'1'}
                remove={id => growlStore.remove(id)}
                messages={growlMessages || []}
            />
        </div>
        <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '1em',
        }}>
            <DashboardFilterBar />
            <AccountButton />
        </div>

        <h1 className="title">
            Dashboard
        </h1>

        <h2 className="subtitle">
            Guten Tag {authStore.user?.profile.name}
        </h2>

        <div className={'fixed-grid has-3-cols'}>
            <div className={'grid'}>
                <div className={'cell'}>
                    <ShippingReceiptExits/>
                </div>
                <div className={'cell'}>
                    <ShippingRecordReceiptExits/>
                </div>
                <div className={'cell'}>
                    <Weighings/>
                </div>
                <div className={'cell'}>
                    <Receipts mode={'record'} title={'Akteneingänge'} />
                </div>
                <div className={'cell'}>
                    <Receipts mode={'document'} title={'Dokumenteneingänge'} />
                </div>
                <div className={'cell'}>
                    <Repository />
                </div>
            </div>
        </div>

    </div>
})

export {
    DashboardPage
}
